import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const fomheadApi = api
  .enhanceEndpoints({ addTagTypes: ['FOMHead'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOMHeads: builder.query<fo_mhead[], string>({
        query: cid => `fomhead/${cid}`,
        providesTags: ['FOMHead']
      }),
      getFOMHeadsMajor: builder.query<fo_mhead[], string>({
        query: cid => `fomhead/major/${cid}`,
        providesTags: ['FOMHead']
      }),
      getFOMHead: builder.query<fo_mhead, string>({
        query: id => `fomhead/byid/${id}`
      }),
      insertFOMHead: builder.mutation({
        query: fomhead => ({
          url: `fomhead/`,
          method: 'POST',
          body: fomhead
        }),
        invalidatesTags: ['FOMHead']
      }),
      updateFOMHead: builder.mutation({
        query: fomhead => ({
          url: `fomhead/`,
          method: 'PUT',
          body: fomhead
        }),
        invalidatesTags: ['FOMHead']
      }),
      deleteFOMHead: builder.mutation({
        query: fomhead => ({
          url: `fomhead/${fomhead.hd_id}`,
          method: 'DELETE',
          body: fomhead
        }),
        invalidatesTags: ['FOMHead']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOMHeadsQuery,
  useLazyGetFOMHeadsQuery,
  useGetFOMHeadsMajorQuery,
  useGetFOMHeadQuery,
  useInsertFOMHeadMutation,
  useUpdateFOMHeadMutation,
  useDeleteFOMHeadMutation
} = fomheadApi;

